<template>
  <div
    id="app"
    v-docked-class
    class="wrapper"
    :class="[backgroundColorClass, backgroundClass]">
    <oie-skip-link></oie-skip-link>
    <oie-the-notification-bar v-if="!hideElement"></oie-the-notification-bar>

    <header class="header-area-sticky">
      <oie-the-top-message-collection v-if="messages" :messages="messages"></oie-the-top-message-collection>

      <oie-the-superuser-header v-if="!hideElement"></oie-the-superuser-header>
      <oie-static-header-actions v-if="!hideElement"></oie-static-header-actions>
      <oie-static-header v-if="!hideElement"></oie-static-header>
      <!-- <oie-static-header-navigation class="sticky-header" :class="{ 'sticky-header--hidden': !showHeader }"></oie-static-header-navigation> -->
      <oie-the-header-navigation :items="navigationItems"></oie-the-header-navigation>
    </header>

    <slot></slot>

    <oie-static-footer v-if="!hideElement"></oie-static-footer>

    <oie-modal-registration></oie-modal-registration>

    <img
      v-if="hideElement"
      sizes="(max-width: 3840px) 100vw, 3840px"
      :srcset="
        require('@/assets/images/global-background_th9kkt_c_scale,w_570.jpg') + ' 570w, ' +
          require('@/assets/images/global-background_th9kkt_c_scale,w_1508.jpg') + ' 1508w, ' +
          require('@/assets/images/global-background_th9kkt_c_scale,w_2167.jpg') + ' 2167w, ' +
          require('@/assets/images/global-background_th9kkt_c_scale,w_2769.jpg') + ' 2769w, ' +
          require('@/assets/images/global-background_th9kkt_c_scale,w_2769.jpg') + ' 2769w, ' +
          require('@/assets/images/global-background_th9kkt_c_scale,w_3840.jpg') + ' 3840w'"
      :src="require('@/assets/images/global-background_th9kkt_c_scale,w_1508.jpg')"
      alt="background-image"
      class="wrapper__image-fit">

    <oie-the-overlay></oie-the-overlay>
    <oie-cookie-banner></oie-cookie-banner>
    <oie-jump-to-top></oie-jump-to-top>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    navigationItems: {
      1: { title: 'Reservdelar', url: '/' },
      2: { title: 'Tillbehör', url: '/' },
      3: { title: 'Hydralik', url: '/' },
      4: { title: 'Kraftöverföring', url: '/' }
    },
    messages: [
      { id: 'slow_site', text: 'The site is slow at the moment please bear with us. Thanks for understanding', mobileText: 'Slow mobile site!' }
    ],
    showHeader: true,
    lastScrollPosition: 0
  }),
  computed: {
    ...mapGetters('ui', ['isCartDocked']),
    ...mapGetters('commerce', ['cart']),
    backgroundColorClass() {
      return this.$route.meta.backgroundColor !== undefined ? `wrapper--${this.$route.meta.backgroundColor}` : undefined
    },
    backgroundClass() {
      return this.$route.meta.backgroundClass !== undefined ? this.$route.meta.backgroundClass : undefined
    },
    hideElement() {
      return this.$route.meta.hideAllElements !== undefined && this.$route.meta.hideAllElements
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    ...mapActions('ui', ['addNotification']),
    onScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 5) { return }
      this.showHeader = currentScrollPosition < this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition
    }
  }
}
</script>

<style lang="scss">
.sticky-header {
  position: sticky;
  transform: translate3d(0, 0, 0);
  transition: 0.2s all ease-out;
}

.sticky-header--hidden {
  transform: translate3d(0, -100%, 0);
}
</style>
